import "@odm/utils/pollyfills";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import loadable from "@loadable/component";
import "@odm/components/helpers/initFA";
import "./i18n";
import { fetchEnvironment } from "config";

const environment = fetchEnvironment();

const App = loadable(() => import("./App"), { fallback: "Loading..." });

const AppLoader = () => {
  return (
    <Suspense fallback={"Loading environment..."}>
      <App resource={environment} />
    </Suspense>
  );
};

async function main() {
  // Start the mocking conditionally.
  if (process.env.REACT_APP_USE_MOCK_SERVER === "true") {
    if (window.location.pathname === process.env.PUBLIC_URL) {
      window.location.pathname = process.env.PUBLIC_URL + "/";
      return;
    }
    const { worker } = require("@odm/mocks/browser");
    await worker.start({
      serviceWorker: {
        url: process.env.PUBLIC_URL + "/mockServiceWorker.js",
      },
    });
  }
  ReactDOM.render(<AppLoader />, document.getElementById("main"));
}

main();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
